import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsCollectorsViewRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-collectors-view',
	path: '/secure/ViewCollector([!%]?[\\w]*).jspa',
	query: ['projectKey'],
};
